import classnames from 'classnames';
import { FunctionComponent, useRef, useEffect, useContext } from 'react';
import { observer } from 'mobx-react';

import styles from './NavBurger.module.sass';
import { HomePageStoreContext } from '../../model/context/home-page.context';

export interface NavBurgerProps {
    onOpen?: () => void;
    onClose?: () => void;
}

const NavBurger: FunctionComponent<NavBurgerProps> = observer(({ children }) => {
    const drawer = useRef<HTMLDivElement>();
    // Context
    const { popoutStore } = useContext(HomePageStoreContext);

    const handleClickOutside = (e) => {
        if (drawer?.current?.contains(e.target)) return;
        popoutStore.toggleNavBurger(false);
    };

    useEffect(() => {
        if (popoutStore.navBurgerOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    });

    return (
        <nav className={styles.container}>
            <div className={styles.bar}>
                <div className={styles.burger} onMouseDown={() => popoutStore.toggleNavBurger()}>
                    <div className={styles.burgerPatty} />
                    <div className={styles.burgerPatty} />
                    <div className={styles.burgerPatty} />
                </div>
                <img
                    className={styles.logo}
                    src="/biz/logo.svg"
                    width={18}
                    height={23}
                    alt="illustration"
                />
            </div>
            <div
                ref={drawer}
                className={classnames(styles.drawer, {
                    [styles.outside]: !popoutStore.navBurgerOpen,
                })}
            >
                {children}
            </div>
            <div
                className={classnames(styles.mask, { [styles.noMask]: !popoutStore.navBurgerOpen })}
            />
        </nav>
    );
});

export default NavBurger;
